// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const camerupt_mega: PokeData = {
  "id": 10087,
  "name": "camerupt-mega",
  "height": 25,
  "weight": 3205,
  "base_experience": 196,
  "types": [
    PokeType.FIRE,
    PokeType.GROUND
  ],
  "api_moves": [
    "tackle",
    "take-down",
    "growl",
    "ember",
    "earthquake",
    "fissure",
    "focus-energy",
    "amnesia",
    "rock-slide",
    "curse",
    "magnitude",
    "yawn",
    "eruption",
    "earth-power",
    "lava-plume",
    "flame-burst"
  ],
  "moves": [
    "tackle",
    "growl",
    "ember",
    "earthquake",
    "fissure",
    "rock-slide",
    "curse",
    "magnitude",
    "eruption",
    "earth-power",
    "sandstorm",
    "magma-storm",
    "fire-ball"
  ],
  "evolution_chain": {
    "id": 162,
    "item": null,
    "species": [
      {
        "name": "numel",
        "order": 350,
        "types": [
          PokeType.FIRE,
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "camerupt",
        "order": 351,
        "types": [
          PokeType.FIRE,
          PokeType.GROUND
        ],
        "evolves_from_species_id": 322,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 33,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 137,
    "speed": 32,
    "ability_power": 231
  },
  "stat_changes": [],
  "catch_rate": 150,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": true,
  "is_gmax": false,
  "regional_variant": null
} as const;
